import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d638882"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "risk-map-card__wrapper" }
const _hoisted_2 = { class: "risk-map-card__header" }
const _hoisted_3 = { class: "risk-map-card__date" }
const _hoisted_4 = { class: "risk-map-card__number" }

import { PropType } from 'vue'
import { ReportType } from '@/shared/types'


export default /*#__PURE__*/_defineComponent({
  props: {
  report: Object as PropType<ReportType>,
  active: Boolean as PropType<boolean>,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'risk-map-card',
      {
        'risk-map-card--active': __props.active,
      },
    ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(__props.report.date_at), 1)
      ]),
      _createElementVNode("p", _hoisted_4, "№" + _toDisplayString(__props.report.id), 1)
    ])
  ], 2))
}
}

})